import React from 'react';
import { Radio } from '@tcc/crate';
import { getMessage } from '@tcc/i18n';
import styles from '../RegionNoteForm.css';

type RegionNoteFormTypeProps = {
  permanent: boolean;
  setPermanent: (boolean) => void;
};

export const RegionNoteFormType = ({ permanent, setPermanent }: RegionNoteFormTypeProps) => (
  <>
    <div className={styles.regionTypeHeader}>
      {getMessage('regionNote.form.type')}
    </div>
    <div className={styles.regionRadioContainer}>
      <Radio
        className={styles.regionRadio}
        checked={!permanent}
        data-test-id="region-note-form-radio-seasonal"
        label={getMessage('scouting.form.seasonal')}
        onChange={() => setPermanent(false)}
      />
      <Radio
        className={styles.regionRadio}
        checked={permanent}
        data-test-id="region-note-form-radio-permanent"
        label={getMessage('scouting.form.permanent')}
        onChange={() => setPermanent(true)}
      />
    </div>
  </>
);
